// LogoSplash.js
import React from 'react';
import './LogoSplash.css'; 


const LogoSplash = () => {
  return (
    <div className="logo-splash">
     <img 
  src="image/Logo1.png" 
  alt="Company Logo" 
  className="logo" 
  style={{ width: "400px", height: "auto" }} 
/>
    </div>
  );
};

export default LogoSplash;